import { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

const ServiceContext = createContext();

export const ServiceProvider = ({ children }) => {
    const [services, setServices] = useState([]);
    // You can have a single state object for user attributes
    const [service, setService] = useState({});
    const [selectedService, setSelectedService] = useState({});
  
  
  
    const setServiceAttributes = (attributes) => {
      // Merge the new attributes with the existing ones
      setService((prevService) => ({ ...prevService, ...attributes }));
     

    };

  
    return (
      <ServiceContext.Provider value={{ services, setServices, service, setServiceAttributes , selectedService, setSelectedService }}>
        {children}
      </ServiceContext.Provider>
    );
  };
  ServiceProvider.propTypes={
      children: PropTypes.node.isRequired
    }
  
  export const useService = () => {
    return useContext(ServiceContext);
  };